import { HandlerEvent } from 'post-robot';
import { getCheckoutData, getUnBindAppInstance } from 'communicator/store/selectors';
import postCheckoutRecogonisedUser from 'communicator/utils/recogonized-user';
import { ValidationError } from 'exports';
import { PurchaseIntentExternalSrciResponse } from 'types/api/intent';
import { CheckoutCommunicatorPayload, CheckoutData } from 'types/visa-sdk/checkout';

export default async function cvvComplete(
  request: HandlerEvent<PurchaseIntentExternalSrciResponse>
): Promise<CheckoutCommunicatorPayload | ValidationError> {
  const checkoutData = getCheckoutData() as CheckoutData;
  postCheckoutRecogonisedUser();

  const checkoutResponse: CheckoutCommunicatorPayload = {
    payload: {
      checkoutResponse: request.data.checkoutResponse || '', // Ensure checkoutResponse is always a string
      ...(checkoutData.idToken && { idToken: checkoutData.idToken }),
      ...(request.data.recognitionToken && { recognitionToken: request.data.recognitionToken }),
      dcfActionCode: 'COMPLETE',
      unbindAppInstance: getUnBindAppInstance()
    }
  };

  return checkoutResponse;
}
